import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=9532c03c&scoped=true&"
import script from "./Buttons.vue?vue&type=script&lang=ts&"
export * from "./Buttons.vue?vue&type=script&lang=ts&"
import style0 from "./Buttons.vue?vue&type=style&index=0&id=9532c03c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9532c03c",
  null
  
)

export default component.exports